import React, { useState } from "react";
import moment from "moment";
import { Modal } from "react-bootstrap";
import SimpleBackdrop from "../SimpleBackdrop";
import createIncidentAPI from "../../API/useCreateIncidentAPI";

const ShopLiftingModal = ({ show, onHide, setSuccessShoplift, settitleData, setBodyData,setShopliftNotificationError }) => {
    // Format date-time to match input[type="datetime-local"]
    const formatDateTimeLocal = (date) => {
        const pad = (num) => String(num).padStart(2, "0");
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
            date.getDate()
        )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    };
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        incidentDate: formatDateTimeLocal(new Date()), // Default to current date
        licencePlateNumber: '',
        note: "",
        fuelCost: "",
        type: 'Shoplift'
    });
    const [errors, setErrors] = useState({});

    const closeModal = () => {
        onHide();
        setErrors({});
        setFormData({
            incidentDate: formatDateTimeLocal(new Date()), // Reset to default date
            licencePlateNumber: '',
            note: "",
            fuelCost: "",
            type: 'Shoplift'
        });
    };

    // Calculate min and max dates (last 15 days and today)
    const currentDate = new Date();
    const minDate = new Date();
    minDate.setDate(currentDate.getDate() - 15);


    // Handle input changes, including date validation
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "incidentDate") {
            const selectedDate = new Date(value);
            const currentDate = new Date();
            const minDate = new Date();
            minDate.setDate(currentDate.getDate() - 15); // 15 days back

            if (selectedDate < minDate || selectedDate > currentDate) {
                alert("Please select a date within the last 15 days and no future date.");
                setFormData((prev) => ({ ...prev, incidentDate: formatDateTimeLocal(currentDate) }));
                return;
            }
        }

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let newErrors = {};
        setSuccessShoplift(false);
        setShopliftNotificationError(false);

        // Validate only mandatory fields (excluding licencePlateNumber)
        Object.keys(formData).forEach((key) => {
            if (!formData[key] && key !== "licencePlateNumber") {
                newErrors[key] = "This field is required";
            }
        });

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        try {
            setLoading(true);

            // Convert to local time format
            const utcTime = moment.utc(formData.incidentDate);
            const localTimeWithOffset = utcTime.local().format("YYYY-MM-DDTHH:mm:ss.SSS");

            // Create a copy of formData and remove 'ocr' if it's blank
            const filteredData = { ...formData, incidentDate: localTimeWithOffset };

            if (!filteredData.ocr) {
                delete filteredData.ocr; // Remove ocr field if blank
            }

            // console.log(filteredData);
            const response = await createIncidentAPI(filteredData);
            // Check if response is valid and contains alertID & eventID
            if (response) {
                closeModal();
                setSuccessShoplift(true);
                settitleData("Incident submitted!");
                setBodyData("The incident has been successfully submitted.");
                setShopliftNotificationError(false);
                setLoading(false);
            }
        } catch (error) {
            closeModal();
            console.error("Error submitting form:", error);
            setSuccessShoplift(false);
            setShopliftNotificationError(true);
            setLoading(false);

        } finally {
            setLoading(false);
            closeModal();
        }
    };


    return (
        <Modal show={show} onHide={onHide} fullscreen>
            <SimpleBackdrop open={loading} onClose={() => setLoading(false)} />
            <div className="modal-dialog modal-dialog-centered modal-fullscreen modal-dialog-scrollable">
                <div className="modal-content" style={{ backgroundColor: "#212529", color: "#ADB5BD" }}>
                    <div className="modal-header">
                        <h5 id="iou-modal" style={{ color: "#FFFFFF", fontWeight: "500", fontFamily: "Ethnocentric" }}>
                            Log ShopLifting Incident
                        </h5>
                        <button type="button" className="btn-close btn-close-white" onClick={closeModal}></button>
                    </div>
                    <div className="modal-body showNormalFont" style={{ padding: "10px" }}>
                        <div className="container-fluid">
                            <form onSubmit={handleSubmit}>
                                <h5 style={{ color: "#fff" }}>Incident Details</h5>
                                <div className="pb-4">
                                    <label style={{ margin: "0px 0px 8px", color: "#adb5bd" }}>
                                        Licence Plate Number (Optional)
                                    </label>
                                    <br />
                                    <input
                                        type="text"
                                        name="licencePlateNumber"
                                        maxLength={10}
                                        value={formData.licencePlateNumber}
                                        onChange={handleChange}
                                        style={{
                                            backgroundColor: "#212529",
                                            color: "#ADB5BD",
                                            borderColor: "#495057",
                                            border: "1px solid #495057",
                                            borderRadius: "5px",
                                            height: "2.3rem",
                                            padding: "6px 12px",
                                            width: "100%",
                                        }}
                                    />
                                    {errors.licencePlateNumber && <div className="text-danger">{errors.licencePlateNumber}</div>}
                                </div>

                                <div className="pb-4">
                                    <label style={{
                                        margin: "0px 0px 8px",
                                        color: "#adb5bd",
                                    }}>When did the incident occur</label>
                                    <div
                                        style={{
                                            border: "1px solid rgb(73, 80, 87)",
                                            width: "100%",
                                            backgroundColor: "#212529",
                                        }}
                                        className="pt-2"
                                    >
                                        <input
                                            type="datetime-local"
                                            value={formData.incidentDate}
                                            onChange={handleChange}
                                            name="incidentDate"
                                            id="incidentTime"
                                            style={{
                                                width: "100%",
                                                height: "35px", // Set a specific height if desired
                                                backgroundColor: "#212529",
                                                color: "#ADB5BD",
                                                border: "none", // Add border styling to match the container
                                                boxSizing: "border-box", // Ensure padding and border are included in the width
                                                padding: "6px 12px",
                                            }}
                                            className="custom-date-picker"
                                            min={formatDateTimeLocal(minDate)}
                                            max={formatDateTimeLocal(currentDate)}
                                        />
                                    </div>
                                    {errors.incidentDate && <div className="text-danger">{errors.incidentDate}</div>}
                                </div>
                                <div className="pb-4">
                                    <label style={{ margin: "0px 0px 8px", color: "#adb5bd" }}>Amount (in Dollars)</label>
                                    <br />
                                    <input
                                        type="number"
                                        name="fuelCost"
                                        value={formData.fuelCost}
                                        onChange={handleChange}
                                        style={{
                                            backgroundColor: "#212529",
                                            color: "#ADB5BD",
                                            borderColor: "#495057",
                                            border: "1px solid #495057",
                                            borderRadius: "5px",
                                            height: "2.3rem",
                                            padding: "6px 12px",
                                            width: '100%'
                                        }}
                                    />
                                    {errors.fuelCost && <div className="text-danger">{errors.fuelCost}</div>}
                                </div>
                                <div className="pb-4">
                                    <label style={{ margin: "0px 0px 8px", color: "#adb5bd" }} >Description</label>
                                    <textarea
                                        name="note"
                                        value={formData.note}
                                        onChange={handleChange}
                                        maxLength={100}
                                        style={{ width: "100%", height: "6.3rem", backgroundColor: "#212529", color: "#ADB5BD" }}
                                    />
                                    {errors.note && <div className="text-danger">{errors.note}</div>}
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="modal-footer showNormalFont">
                        <button className="btn btn-secondary me-2 w-25 custom-btn" onClick={closeModal}>
                            Close
                        </button>
                        <button onClick={handleSubmit} className="btn btn-primary w-25 custom-btn">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ShopLiftingModal;